// extracted by mini-css-extract-plugin
module.exports = {"removal_pending":"TransactionException_removal_pending__1xpw0"};